import HttpRouter from '../services/HttpRouter'

export default {
    getClasses({ schoolId }, successCallback, failedCallback = () => {}) {
        HttpRouter.get(null, 'school/' + schoolId + '/classes', {
            params: {
                include: 'teacher'
            }
        }).then(
            response => {
                var classes = this.prepareClasses(response.data, schoolId)
                successCallback(classes)
            },
            error => {
                console.error('Problem loading classes', error)
                failedCallback(error)
            }
        )
    },

    prepareClasses(classes, schoolId) {
        classes.forEach(c => {
            c.name = c.name.replace(/&quot;/g, '"')
            c.organization_id = schoolId
        })

        return classes
    },

    updateClass({ schoolId, classObject }) {
        return new Promise((resolve, reject) => {
            HttpRouter.patch(null, 'school/' + schoolId + '/classes', [classObject]).then(function(response) {
                resolve(response.data.data)
            }, function(response) {
                const error = response.body && response.body.message ? response.body.message : 'An error occurred!'
                reject(error)
            })
        })
    },

    addClass({ schoolId, classObject }) {
        return new Promise((resolve, reject) => {
            HttpRouter.post(null, 'school/' + schoolId + '/classes', classObject).then(function(response) {
                resolve(response.data.data)
            }, function(response) {
                const error = response.body && response.body.message ? response.body.message : 'An error occurred!'
                reject(error)
            })
        })
    },

    deleteClass({ schoolId, classObject }, successCallback) {
        HttpRouter.delete(null, 'school/' + schoolId + '/classes/' + classObject.id).then(function(response) {
            successCallback()
        }, function(response) {
            console.error('Problem deleting class', response)
        })
    }
}
